import { useCallback, RefObject } from 'react'

export interface ChartExportHandle {
  getExportData: () => any[]
}

export function useChartExportCSV(ref: RefObject<ChartExportHandle>, filename: string) {
  return useCallback(() => {
    if (ref.current && ref.current.getExportData) {
      const data = ref.current.getExportData()
      if (!data || !data.length) return
      const keys = Object.keys(data[0])
      const csvRows = [
        keys.join(','),
        ...data.map((row) => keys.map((k) => JSON.stringify(row[k] ?? '')).join(','))
      ]
      const csv = csvRows.join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      URL.revokeObjectURL(url)
    }
  }, [ref, filename])
}
